import { ErrorToast, SuccessToast } from "../components/toastify";
import HandleLogout from "../hooks/handleLogout";
import { setShowPreloader } from "../store/activePage";
import { setUserLoginStatus } from "../store/userStatus";
import { AxiosPostMethod } from "./customAxios";

const VerifyOtp = async (otp, navigate, dispatch) => {
  dispatch(setShowPreloader(true)); // Show preloader before API call
  const successRes = await await AxiosPostMethod(`verify/otp`, {
    otp,
  });
  dispatch(setShowPreloader(false)); // Show preloader before API call
  if (successRes.status === 200) {
    dispatch(setUserLoginStatus(true));
    localStorage.setItem(
      "customer-name",
      `${successRes.data.data.user_info.first_name} ${successRes.data.data.user_info.last_name}`
    );
    if (successRes.data.data.user_info.mobile) {
      localStorage.setItem("customer-mobile", successRes.data.data.user_info.mobile);
    }
    if (successRes.data.data.user_info.email) {
      localStorage.setItem("customer-email", successRes.data.data.user_info.email);
    }
    localStorage.setItem("dwt-cust-tok", successRes.data.data.access_token);
    navigate("/dashboard/home");
    SuccessToast("Welcome Back!");
  } else {
    if (successRes?.status === 401) HandleLogout();
    ErrorToast("OTP verification failed.");
    return null;
  }
};

export default VerifyOtp;
